// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "e8bfb8ca3b9d9f36842d" + ".js";
};